// extracted by mini-css-extract-plugin
module.exports = {"container":"delivery-details__container___2xctz"};